<template>
  <div>
    <v-data-table
      dense
      multi-sort
      :headers="headers"
      :items="items"
      :loading="loading"
      class="elevation-1">
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-icon large>mdi-folder-text</v-icon>
          <v-divider vertical class="mx-2"></v-divider>
          <v-toolbar-title>Resurse</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-divider vertical class="mx-4" inset></v-divider>
          <v-btn icon color="primary" @click="openItemDialog" title="Adăugare resursă">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.id="{ item }">
        <span style="display: inline-block; width: 50px" class="text-truncate" :title="item.id">
          {{ item.id }}
        </span>
      </template>
      <template v-slot:item.content="{ item }">
        <div v-html="item.content"></div>
      </template>
      <template v-slot:item.thumb="{ item }">
        <v-img
          class="ma-auto"
          v-if="item.thumb"
          :src="item.thumb"
          max-height="20"
          max-width="40"
          contain>
        </v-img>
      </template>
      <template v-slot:item.file="{ item }">
        <a :href="item.file" download target="_blank" v-if="item.file" style="text-decoration: none">
          <v-icon>mdi-download</v-icon>
        </a>
      </template>
      <template v-slot:item.actions="{ item }">
        <div style="white-space: nowrap">
          <v-icon
            small
            class="mr-2"
            @click="editItem(item)"
            color="accent"
            title="editeaza cont">
            mdi-pencil
          </v-icon>
          <v-icon
            small
            class="mr-2"
            @click="deleteItem(item)"
            color="error"
            title="sterge cont">
            mdi-delete
          </v-icon>
        </div>
      </template>
    </v-data-table>

    <v-dialog
      persistent
      scrollable
      v-model="itemForm"
      width="500">
      <v-card max-height="75vh">
        <v-card-title>
          <span>{{ itemAction === "add" ? "Adaugare" : "Modificare" }} Resursă</span>
          <v-spacer></v-spacer>
          <v-btn icon small>
            <v-icon small color="error" @click="closeItemDialog">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form v-model="validForm" ref="form">
            <v-text-field
              v-model="item.title"
              label="Titlu"
              hint="Text ce apare la hover pe resursă."
              required
              :rules="[rules.required]">
            </v-text-field>
            <v-textarea
              v-model="item.content"
              label="Conținut"
              hint="Text care apare la click pe resursă. Poate conține cod HTML."
              required
              :rules="[rules.required]">
            </v-textarea>
            <v-text-field
              v-model.number="item.index"
              type="number"
              min="1"
              step="1"
              label="Index"
              hint="Resursele vor fi ordonate după acest câmp."
              required
              :rules="[rules.required]">
            </v-text-field>
            <v-file-input
              v-model="item.thumbBuffer"
              label="Pictogramă"
              ref="thumbField"
              hint="Click pentru a încărca un fișier care va reprezenta pictograma resursei."
              :prepend-icon="null">
            </v-file-input>
            <v-file-input
              v-model="item.fileBuffer"
              label="Fișier"
              ref="fileField"
              hint="Click pentru a încărca un fișier ce va putea fi descarcat de utilizatori."
              :prepend-icon="null">
            </v-file-input>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-alert type="error" v-if="message" dismissible @input="alertChanged">{{ message }}</v-alert>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" outlined @click="closeItemDialog">Închide</v-btn>
          <v-btn color="primary" @click="saveItem">Salvează Resursă</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      persistent
      scrollable
      v-model="deleteItemDialog"
      width="500">
      <v-card max-height="75vh">
        <v-card-title>Confirmați ștergerea?</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" outlined @click="cancelDelete">Anulează ștergerea</v-btn>
          <v-btn color="primary" @click="confirmDelete">Șterge Resursă</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "ResourcesComponent",

  data: () => ({
    headers: [
      {
        text: "id",
        value: "id",
        align: "start",
        sortable: false,
        filterable: false
      },
      {
        text: "titlu",
        value: "title",
        align: "left",
        sortable: true,
        filterable: true
      },
      {
        text: "conținut",
        value: "content",
        align: "left",
        sortable: true,
        filterable: true
      },
      {
        text: "index",
        value: "index",
        align: "right",
        sortable: false,
        filterable: false
      },
      {
        text: "fișier",
        value: "file",
        align: "center",
        sortable: false,
        filterable: false
      },
      {
        text: "pictogramă",
        value: "thumb",
        align: "center",
        sortable: false,
        filterable: false
      },
      {
        text: "acțiuni",
        value: "actions",
        sortable: false,
        filterable: false
      }
    ],
    item: {
      id: null,
      title: null,
      content: null,
      thumb: null,
      file: null,
      index: null,
      thumbBuffer: null,
      fileBuffer: null
    },
    itemForm: false,
    itemAction: "add",
    validForm: true,
    deleteItemDialog: false,
    deleteItemID: null,
    rules: {
      required: val => !!val || "Câmpul nu poate fi gol!"
    },
    message: null
  }),

  computed: {
    items() {
      return this.$store.getters.resourcesItems;
    },
    loading() {
      return this.$store.getters.resourcesLoading;
    },
    user() {
      return this.$store.getters.user;
    }
  },

  methods: {
    resetForm() {
      this.$refs.form.resetValidation();
      this.item = Object.assign(
        this.item,
        {},
        JSON.parse(JSON.stringify(defaultItem))
      );
      this.itemAction = "add";
    },
    closeItemDialog() {
      this.itemForm = false;
      this.item = Object.assign(
        this.item,
        {},
        JSON.parse(JSON.stringify(defaultItem))
      );
      this.resetForm();
      this.message = null;
    },
    openItemDialog() {
      this.itemForm = true;
      this.itemAction = "add";
    },
    async saveItem() {
      const valid = this.$refs.form.validate();
      if (valid) {
        const payload = Object.assign({}, this.item);
        const result = await this.$store.dispatch("saveResource", payload);
        if (result === true) {
          this.closeItemDialog();
        } else {
          this.message =
            "Ne pare rău. A apărut o eroare la procesarea cererii...";
        }
      }
    },
    editItem(item) {
      this.item.id = item.id;

      this.item.title = item.title;
      this.item.content = item.content;
      this.item.index = item.index;

      this.itemAction = "edit";
      this.itemForm = true;
    },
    deleteItem(item) {
      this.deleteItemID = item.id;
      this.deleteItemDialog = true;
    },
    confirmDelete() {
      const payload = this.deleteItemID;
      this.$store.dispatch("deleteResource", payload);
      this.deleteItemID = null;
      this.deleteItemDialog = false;
    },
    cancelDelete() {
      this.deleteItemID = null;
      this.deleteItemDialog = false;
    },
    alertChanged($event) {
      if (!$event) this.message = null;
    }
  },
  mounted() {
    this.$store.dispatch("fetchResources");
  }
}

const defaultItem = {
  id: null,
  title: null,
  content: null,
  thumb: null,
  file: null,
  index: null,
  thumbBuffer: null,
  fileBuffer: null
};
</script>
